<template>
  <div id="project">
    <h4>{{title}}</h4>
    <p class="text">{{blurb}}</p>
    <a v-bind:href="link" target="_blank">{{link}}</a>
  </div>
</template>

<script>
export default {
  name: 'project',
  props: {
    title: String,
    blurb: String,
    link: String
  }
}
</script>
<style>
#project {
  position: relative;
  display: block;
  width: 50%;
  border: 1px solid black;
  margin: auto;
  padding: 0.5%;
  border-radius: 10px;
  margin-bottom: 2%;
}
</style>



// WEBPACK FOOTER //
// src/components/project.vue